<template>
  <div>
    <PageAllow controller="MaterialProfitAnalyzeHistories" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetime
                type="month"
                v-model="dateMonth"
                :label="$t('MaterialProfitAnalyzeHistories.Fields.month')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                v-if="$permission.permissionAllow('MaterialProfitAnalyzeHistories', 'export')"
                @click.stop="materialProfitAnalyzeHistoriesExport()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("MaterialProfitAnalyzeHistories.batchExports") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="Keyword = $event"
                    :label="$t('MaterialProfitAnalyzeHistories.Fields.keyword')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="profitDetails"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:item.sale_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.sale_total_price | formatMoney }}
            </template>
            <template v-slot:item.in_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.in_total_price | formatMoney }}
            </template>
            <template v-slot:item.begin_stock_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.begin_stock_total_price | formatMoney }}
            </template>
            <template v-slot:item.end_stock_total_price="{ item }">
              {{ $t("Global.money") }}{{ item.end_stock_total_price | formatMoney }}
            </template>
            <template v-slot:item.profit="{ item }">
              {{ $t("Global.money") }}{{ item.profit | formatMoney }}
            </template>
            <template v-slot:item.profit_rate="{ item }">
              {{ item.profit_rate | formatMoney }}{{ $t("Global.rate") }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import receipBillAnalyze from "@/api/receip_bill_analyze";

const defaultOptions = {
  month: new Date().toISOString().substr(0, 7),
  keyword: '',
};

export default {
  data: () => ({
    profitDetails: [],
    paging: {},
    dateMonth: new Date().toISOString().substr(0, 7),
    Keyword: "",
    options: JSON.parse(
      sessionStorage.getItem("material-profit-analyze-histories-options")
        ? sessionStorage.getItem("material-profit-analyze-histories-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetime,
    PageAllow,
    SearcherKeyword,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receiptBillAnalyze"),
        disabled: false,
        href: "/receipt-bill-analyze",
      },
      {
        text: i18n.t("Nav.materialProfitAnalyzeHistories"),
        disabled: true,
        href: "/receipt-bill-analyze/material-analyze-histories",
      },
    ],
    headers() {
      let headers = [
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.sale_total_num"),
          align: "start",
          sortable: false,
          value: "sale_total_num",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.sale_total_price"),
          align: "start",
          sortable: false,
          value: "sale_total_price",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.in_total_num"),
          align: "start",
          sortable: false,
          value: "in_total_num",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.in_total_price"),
          align: "start",
          sortable: false,
          value: "in_total_price",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.begin_current_count"),
          align: "start",
          sortable: false,
          value: "begin_current_count",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.begin_stock_total_price"),
          align: "start",
          sortable: false,
          value: "begin_stock_total_price",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.end_current_count"),
          align: "start",
          sortable: false,
          value: "end_current_count",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.end_stock_total_price"),
          align: "start",
          sortable: false,
          value: "end_stock_total_price",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.profit"),
          align: "start",
          sortable: false,
          value: "profit",
        },
        {
          text: i18n.t("MaterialProfitAnalyzeHistories.Fields.profit_rate"),
          align: "start",
          sortable: false,
          value: "profit_rate",
        },
      ];
      return headers;
    },
    ...mapState(["stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("material-profit-analyze-histories", [])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (typeof this.options.month != "undefined")
              this.dateMonth = this.options.month;
        } else this.resetSearch();
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.Keyword,
      });
    },
    resetSearch() {
      this.keyword = null;
      this.dateMonth = new Date().toISOString().substr(0, 7);
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getMaterialProfitAnalyzeHistoriesFromAPI() {
      this.loading = true;
      receipBillAnalyze.getMaterialProfitAnalyzeHistories(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.profitDetails = response.data.profit_details;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    materialProfitAnalyzeHistoriesExport() {
      receipBillAnalyze.materialProfitAnalyzeHistoriesExport(Object.assign({}, this.options));
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getMaterialProfitAnalyzeHistoriesFromAPI();
        sessionStorage.setItem("material-profit-analyze-histories-options", JSON.stringify(this.options));
      },
    },
    dateMonth: {
      handler() {
        if (this.dateMonth == "") {
          this.dateMonth = new Date().toISOString().substr(0, 7);
        } else {
          this.options.month = this.dateMonth;
        }
      },
    },
  },
};
</script>

<style>
</style>